function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ListEdit from "../list/ListEdit";
import { Icon } from '@signicat/designi/components/icons';
import t from "../../scripts/i18n";
import "../../styling/components/contacts/Menu.css";

var Menu = function Menu(props) {
  var history = useHistory();
  var location = useLocation();
  var currentUserId = useSelector(function (state) {
    return state.app.userId;
  });
  var contactsUsers = useSelector(function (state) {
    return state.contacts.users;
  });
  var contactLists = useSelector(function (state) {
    return state.contactLists.lists;
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expandDelegated = _useState2[0],
      setExpandDelegated = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      expandLists = _useState4[0],
      setExpandLists = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      ListEditOpen = _useState6[0],
      setListEditOpen = _useState6[1];

  var getClassName = function getClassName(initialClass, pathsForActive) {
    if (location.pathname.includes('edit')) {
      return initialClass + ' ' + (pathsForActive.includes(location.pathname.substring(0, location.pathname.lastIndexOf('/'))) ? 'active' : '');
    }

    return initialClass + ' ' + (pathsForActive.includes(location.pathname) ? 'active' : '');
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName('item border-bottom', ['/contacts', '/contacts/new', '/contacts/edit']),
    onClick: function onClick() {
      return history.push('/contacts');
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "contacts"
  }), /*#__PURE__*/React.createElement("span", null, t('menu_contacts'))), /*#__PURE__*/React.createElement("div", {
    className: "item",
    onClick: function onClick() {
      return setExpandLists(!expandLists);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: expandLists ? 'expandLess' : 'expandMore'
  }), /*#__PURE__*/React.createElement("span", null, t('menu_lists'))), expandLists && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "list"
  }, contactLists && contactLists.map(function (l, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: getClassName('item border-bottom', ["/contacts/list/".concat(l.id)]),
      onClick: function onClick() {
        return history.push("/contacts/list/".concat(l.id));
      },
      key: i
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "contacts"
    }), /*#__PURE__*/React.createElement("span", null, l.name, l.portalUserId !== currentUserId ? " (".concat(t('menu_shared_list'), ")") : ''));
  })), /*#__PURE__*/React.createElement("div", {
    className: "item border-bottom",
    onClick: function onClick() {
      return setListEditOpen(true);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "add"
  }), /*#__PURE__*/React.createElement("span", null, t('menu_create_list')))), /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "item",
    onClick: function onClick() {
      return setExpandDelegated(!expandDelegated);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: expandDelegated ? 'expandLess' : 'expandMore'
  }), /*#__PURE__*/React.createElement("span", null, t('menu_shared_contacts'))), expandDelegated && /*#__PURE__*/React.createElement("div", {
    className: "list"
  }, contactsUsers && contactsUsers.length > 0 ? contactsUsers.map(function (u, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: getClassName('item border-bottom', ["/contacts/".concat(u.userId)]),
      onClick: function onClick() {
        return history.push("/contacts/".concat(u.userId));
      },
      key: i
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "contacts"
    }), /*#__PURE__*/React.createElement("span", null, "From ", "".concat(u.firstName, " ").concat(u.lastName)));
  }) : /*#__PURE__*/React.createElement("div", {
    className: getClassName('item border-bottom', [])
  }, /*#__PURE__*/React.createElement("span", null, t('menu_no_shared_contacts'))))), /*#__PURE__*/React.createElement("div", {
    className: getClassName('item', ['/contacts/import']),
    onClick: function onClick() {
      return history.push('/contacts/import');
    }
  }, /*#__PURE__*/React.createElement("span", null, t('menu_import'))), ListEditOpen && /*#__PURE__*/React.createElement(ListEdit, {
    onClose: function onClose() {
      return setListEditOpen(false);
    }
  }));
};

export default Menu;